import { createFileRoute, redirect } from "@tanstack/react-router";
import { canonicalFeaturePath } from "../../../shared/src/feature-paths";

/** A page under Shop's old address (/shop/...) lands on the same page under Merch. */
export const Route = createFileRoute("/shop/$")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: canonicalFeaturePath(location.href), statusCode: 308 });
  },
});
